/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutType } from './rolloutType';


export interface IrrUpgradeActionSpec { 
    type?: RolloutType;
    /**
     * The target version for the IRR upgrade.
     */
    to_version: string;
}
export namespace IrrUpgradeActionSpec {
}


